<template>
<!-- FINAL MEMBER -->
  <div class="wrapper">
    <div>
    
    <CRow class="mt-3">
      <div>
      </div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                       <CAlert color="info" class="mb-4 mt-3">
                         This report shows listing of members of iCare.
                      </CAlert>
                        <Datatable 
                            :items="items" 
                            :icare="icare"
                            :fields="fields" 
                            :meta="meta" 
                            :is_uuid="true"
                            @per_page="handlePerPage" 
                            @pagination="handlePagination" 
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            @icare_filter="handleIcareFilter"
                            :btn_show="false"
                            :btn_edit="false"
                            :btn_edit_phone="true"
                            :btn_edit_address="true"
                            :btn_edit_birthday="true"
                            :btn_deactivate="false"
                            :btn_reactivate="false"
                            :btn_delete="false"
                            @show="handleShow"
                            @edit="handleEdit"
                            @editphone="handleEditPhone"
                            @editaddress="handleEditAddress"
                            @editbirthday="handleEditBirthday"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        
                           />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
    <membermodal></membermodal>
    <alertmodal></alertmodal>
    <membermodalbirthday></membermodalbirthday>
    <membermodaladdress></membermodaladdress>
    <membermodalphone></membermodalphone>
  </div>
  </div>  
</template>

<script>
import Datatable from '@/components/datatables_icarecoreteam_report.vue'; 
import axios from 'axios';
import report from '@/services/report';
import icare from '@/services/icare';
import newcomer from '@/services/newcomer';
import service from '@/services/service';
import keperluan from '@/services/keperluan';
import membermodal from './member_modal';
import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import membermodalphone from '@/views/member/member_modal_phone';
import membermodaladdress from '@/views/member/member_modal_address1';
import membermodalbirthday from '@/views/member/member_modal_birthday';
import store from '@/store.js'
import Multiselect from 'vue-multiselect'

const token = localStorage.getItem('token');

export default {
  name: 'MemberTables',
  components: { Datatable, membermodal, alertmodal,Multiselect,membermodalbirthday,membermodalphone,membermodaladdress },
  data () {
    return {
      form:{
        firstname:'',
        lastname:'',
        email:'',
        dob:''
      },
      updateSubmit: false,
      fields: [
          {key: 'firstname', sortable: false},
          {key: 'profilepic', sortable: false},
          {key: 'icare', sortable: false},
          {key: 'email', sortable: false},
          {key: 'mobile_phone', sortable: false},
          {key: 'address1', sortable: false},
          {key: 'dob', sortable: false},
      ],
      items: [],
      icare: [],
      options_member:[],
      options_service:[],
      options_keperluan: [], 
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
      icare_id: 0,
    }
   },
    created() {

  },

   mounted (){
     this.loadData()

      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
    openModalEditPhone(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Phone', mode:'editphone', data:id}
        EventBus.$emit('OPEN_MODAL_PHONE', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
    openModalEditAddress(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Address', mode:'editaddress', data:id}
        EventBus.$emit('OPEN_MODAL_ADDRESS', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
    openModalEditBirthday(id){
      //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit member (including assign spouse/icare/department/class/etc)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Birthday', mode:'editbirthday', data:id}
        EventBus.$emit('OPEN_MODAL_BIRTHDAY', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        } 
      }
      //SET END
    },
     loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        search: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
        icare_id: this.icare_id,
      }
      report.getIcareMemberReport(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          this.icare = res.icares
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active,
              icare_id: res.icare_id
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    handlePerPage(val) {
        this.per_page = val 
        this.loadData() 
    },
    
    handlePagination(val) {
        this.current_page = val 
        this.loadData()
    },
    
    handleSearch(val) {
        this.search = val 
        this.current_page = 1 
        this.loadData() 
    },
  
    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },
    
    handleIsActive(val) {
        this.is_active = val 
        this.loadData() 
    },
    handleIcareFilter(val) {
        this.icare_id = val 
        this.loadData() 
    },
////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val) 
    }, 
    handleEdit(val) {
        this.openModalEdit(val) 
    },  
    handleEditPhone(val) {
        this.openModalEditPhone(val) 
    },  
    handleEditAddress(val) {
        this.openModalEditAddress(val) 
    },   
    handleEditBirthday(val) {
        this.openModalEditBirthday(val) 
    },  
    handleDeactivate(val) {
        this.deactivate(val)       
    },
    handleReactivate(val) {
        this.reactivate(val)       
    },
    handleGrantWebAccess(val) {
      if(confirm("Do you really want to grant web access?")){
        member.grantwebaccess(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }   
    },
    handleResetPassword(val) {
      if(confirm("Do you really want to reset password?")){
        member.resetpassword(val)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }       
    },    

  }
  
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
